import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { T } from 'shared/helper/translate';
import RubriqEditingStatus from './RubriqEditingStatus';
var RubriqEditsHeader = function RubriqEditsHeader(_ref) {
  var loadingCheckDocumentModal = _ref.loadingCheckDocumentModal,
    onCheckDocument = _ref.onCheckDocument;
  return /*#__PURE__*/React.createElement("div", {
    className: "border-bottom d-flex justify-content-between align-items-center justify-content-md-end gap-md-4 py-2"
  }, /*#__PURE__*/React.createElement(RubriqEditingStatus, null), /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "not-global btn btn-primary rounded-3",
    onClick: function onClick() {
      return onCheckDocument();
    },
    disabled: loadingCheckDocumentModal
  }, /*#__PURE__*/React.createElement(T, {
    source: "check document"
  }), loadingCheckDocumentModal && /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    className: "ms-1",
    icon: "fa-solid fa-spinner-scale",
    spin: true
  })));
};
export default RubriqEditsHeader;